import React from 'react';
import { FiBriefcase, FiShoppingCart, FiUser } from 'react-icons/fi';
import Table from '../common/Table/Table';
import EditButton from '../common/ActionButton/EditButton';
import AddToTodoButton from '../common/ActionButton/AddToTodoButton';
import WhatsAppButton from '../common/ActionButton/WhatsAppButton';
import MailButton from '../common/ActionButton/MailButton';
import MarkTypeButton from '../common/ActionButton/MarkTypeButton';
import DeleteButton from '../common/ActionButton/DeleteButton';
// import './ContactTable.css';
import { API_BASE } from '../../config';

const CompanyTable = ({
  companies,
  onCompanyClick,
  onEditClick,
  refreshCompanies,
}) => {

  const deleteCompany = async (companyId, e) => {
    e.stopPropagation();
    if (!window.confirm('Are you sure you want to delete this company?')) {
      return;
    }
    try {
      const response = await fetch(`${API_BASE}/api/companies/${companyId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to delete Company');
      }
      refreshCompanies();
    } catch (error) {
      console.error('Error:', error);
      alert(error.message || 'Failed to delete contact');
    }
  };

  const columns = [
    { header: 'Company Name', accessor: 'name' },
    { header: 'Company Industry' },
    { header: 'Website' },
    { header: 'City' },
    { header: 'State' },
    { header: 'Actions', className: 'actions-header' }
  ];

  const renderRow = (company) => (
    <>
      <td>{company.name}</td>
      <td>{company.email || '-'}</td>
      <td>{company.phone || '-'}</td>
      <td>{company.company_name || '-'}</td>
      <td>{company.company_industry || '-'}</td>
      <td>
        {company.company_type === 'manufacturer' && (
          <span className="badge manufacturer">Manufacturer</span>
        )}
        {company.company_type === 'buyer' && (
          <span className="badge buyer">Buyer</span>
        )}
        {company.company_type === 'contractor' && (
          <span className="badge contractor">Contractor</span>
        )}
        {!company.company_type && '-'}
      </td>
      <td className="actions-cell">
        <div className="action-buttons">
          <EditButton
            onClick={(e) => {
              e.stopPropagation();
              onEditClick(company.id);
            }}
            className="lead-edit-btn"
            title="Edit"
          />
      <DeleteButton
        title="Delete"
        className="delete-btn"
        onClick={(e) => deleteCompany(company.id, e)}
      />
    </div>
  </td>
    </>
  );

  return (
    <Table
      columns={columns}
      data={companies}
      renderRow={renderRow}
      className="Companies-table"
      onRowClick={(company) => onCompanyClick(company.id)}
    />
  );
};

export default CompanyTable;
